/**
 * Converts kebab-case icon names to PascalCase for Lucide React
 * Example: "shopping-bag" -> "ShoppingBag"
 */
export const kebabToPascalCase = (kebabStr: string): string => {
    return kebabStr
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join("");
};
